import React, { useEffect } from "react";
import { useLocation, Routes, Route } from "react-router-dom";

import Menu from "./componentes/Menu/Menu";
import Home from "./pages/Home/Home";
import ServicosEngAplicadaProjTec from "./pages/ServicosEngAplicadaProjTec/ServicosEngAplicadaProjTec";
import ServicosEstRegAmbiental from "./pages/ServicosEstRegAmbiental/ServicosEstRegAmbiental";
import ServicosConsultoriaGesAmbiental from "./pages/ServicosConsultoriaGesAmbiental/ServicosConsultoriaGesAmbiental";
import ServicosCapacitacaoETreinamento from "./pages/ServicosCapacitacaoETreinamento/ServicosCapacitacaoETreinamento";
import ServicosGestaoEstrategicaESG from "./pages/ServicosGestaoEstrategicaESG/ServicosGestaoEstrategicaESG";
import ServicosSegurancaDoTrabalho from "./pages/ServicosSegurancaDoTrabalho/ServicosSegurancaDoTrabalho";
import ProjetoLicenciamentoAmbiental from "./pages/ProjetoLicenciamentoAmbiental/ProjetoLicenciamentoAmbiental";
import ProjetoRecuperacaoAreasDegradadas from "./pages/ProjetoRecuperacaoAreasDegradadas/ProjetoRecuperacaoAreasDegradadas";
import ProjetoProgramaEducacaoAmbiental from "./pages/ProjetoProgramaEducacaoAmbiental/ProjetoProgramaEducacaoAmbiental";
import Footer from "./pages/Footer/Footer";

import useScrollReveal from "./useScrollReveal";
import ProjetoGereciamentoResiduosSolidos from "./pages/ProjetoGereciamentoResiduosSolidos/ProjetoGereciamentoResiduosSolidos";

function AppContent() {
  const location = useLocation();

  useScrollReveal([location.pathname]);

  useEffect(() => {
    if (location.state?.scrollTo) {
      const id = location.state.scrollTo;

      const el = document.getElementById(id);

      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);
  
  return (
    <>
      <Menu />

      <Routes>
        <Route path="/" element={<Home />} />

        <Route
          path="/servicos/engenharia-aplicada-e-projetos-tecnicos"
          element={<ServicosEngAplicadaProjTec />}
        />

        <Route
          path="/servicos/estudos-e-regularizacao-ambiental"
          element={<ServicosEstRegAmbiental />}
        />

        <Route
          path="/servicos/consultoria-monitoramento-e-gestao-ambiental"
          element={<ServicosConsultoriaGesAmbiental />}
        />

        <Route
          path="/servicos/capacitacao-e-treinamento-ambiental"
          element={<ServicosCapacitacaoETreinamento />}
        />

        <Route
          path="/servicos/gestao-estrategica-em-esg"
          element={<ServicosGestaoEstrategicaESG />}
        />

        <Route
          path="/servicos/seguranca-do-trabalho"
          element={<ServicosSegurancaDoTrabalho />}
        />

        <Route
          path="/projetos/licenciamento-ambiental"
          element={<ProjetoLicenciamentoAmbiental />}
        />

        <Route
          path="/projetos/recuperacao-de-areas-degradadas"
          element={<ProjetoRecuperacaoAreasDegradadas />}
        />

        <Route
          path="/projetos/programa-de-educacao-ambiental"
          element={<ProjetoProgramaEducacaoAmbiental />}
        />

        <Route
          path="/projetos/gerenciamento-de-residuos-solidos"
          element={<ProjetoGereciamentoResiduosSolidos />}
        />

        <Route path="*" element={<h1>Página não encontrada</h1>} />
      </Routes>

      <Footer />
    </>
  );
}

export default AppContent;
